import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { referenceHomeContent } from './referenceHomeContent';
import './referenceHome.css';
export default function V21Home() {
    const root = useRef(null);
    const navigate = useNavigate();
    useEffect(() => {
        const el = root.current;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const band = el.querySelector('#band');
        const media = el.querySelector('#bandMedia');
        const video = el.querySelector('#bandVideo');
        const play = el.querySelector('#bandPlay');
        const sound = el.querySelector('#bandSound');
        const say = el.querySelector('#sayText');
        const words = [...say.querySelectorAll('.w')];
        let frame = 0;
        let visible = false;
        let userPaused = false;
        const tryPlay = () => {
            if (visible && !motion.matches && !userPaused) video.play().catch(() => {});
        };
        const paint = () => {
            frame = 0;
            const rect = band.getBoundingClientRect();
            const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - window.innerHeight)));
            const eased = 1 - Math.pow(1 - Math.min(progress / 0.72, 1), 3);
            const minimum = window.innerWidth <= 760 ? 76 : 52;
            media.style.setProperty('--bw', `${motion.matches ? 100 : minimum + (100 - minimum) * eased}%`);
            const textRect = say.getBoundingClientRect();
            const textProgress = (window.innerHeight * 0.85 - textRect.top) / (window.innerHeight * 0.4 + textRect.height);
            const lit = Math.round(Math.max(0, Math.min(1, textProgress)) * (words.length + 4));
            words.forEach((word, index) => word.classList.toggle('on', motion.matches || index < lit));
            const keyrun = el.querySelector('#keyrun');
            keyrun.classList.toggle('lit', keyrun.querySelector('.w').classList.contains('on'));
        };
        const schedule = () => { if (!frame) frame = window.requestAnimationFrame(paint); };
        const updateMotion = () => {
            const hero = el.querySelector('#heroLoop');
            hero.autoplay = !motion.matches;
            if (motion.matches) { hero.pause(); video.pause(); }
            else { hero.play().catch(() => {}); tryPlay(); }
            video.controls = motion.matches;
            paint();
        };
        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
            visible = entries[0].isIntersecting;
            if (visible) tryPlay(); else video.pause();
        }, { threshold: 0.1 }) : null;
        observer?.observe(video);
        const updatePlay = () => {
            play.textContent = video.paused ? 'Play' : 'Pause';
            play.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        };
        const togglePlay = () => {
            userPaused = !video.paused;
            if (userPaused) video.pause(); else video.play().catch(() => {});
        };
        const toggleSound = () => {
            video.muted = !video.muted;
            sound.setAttribute('aria-pressed', String(!video.muted));
            el.querySelector('#bandSoundLabel').textContent = video.muted ? 'Sound on' : 'Sound off';
            if (!video.muted) { userPaused = false; video.play().catch(() => {}); }
        };
        play.addEventListener('click', togglePlay);
        sound.addEventListener('click', toggleSound);
        video.addEventListener('play', updatePlay);
        video.addEventListener('pause', updatePlay);
        video.addEventListener('canplay', tryPlay);
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        document.addEventListener('visibilitychange', schedule);
        updatePlay();
        updateMotion(); motion.addEventListener('change',updateMotion);
        const activate = (tab, focus = false) => {
            const group = tab.closest('[role="tablist"]');
            for (const sibling of group.querySelectorAll('[role="tab"]')) {
                const active = sibling === tab;
                sibling.setAttribute('aria-selected', String(active));
                sibling.tabIndex = active ? 0 : -1;
                const panel = el.querySelector(`#${sibling.getAttribute('aria-controls')}`);
                if (panel) panel.hidden = !active;
            }
            if (focus) tab.focus();
        };
        const click = event => {
            const tab = event.target.closest('[role="tab"]');
            if (tab) activate(tab);
            const link = event.target.closest('a[href]');
            if (link && link.getAttribute('href').startsWith('/') && !event.metaKey && !event.ctrlKey) { event.preventDefault(); navigate(link.getAttribute('href')); }
        };
        const keydown = event => {
            const tab = event.target.closest('[role="tab"]');
            if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();
            const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
            const index = tabs.indexOf(tab);
            activate(tabs[event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length], true);
        };
        el.addEventListener('click',click); el.addEventListener('keydown',keydown);
        return () => {
            observer?.disconnect();
            window.cancelAnimationFrame(frame);
            window.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
            document.removeEventListener('visibilitychange', schedule);
            play.removeEventListener('click', togglePlay);
            sound.removeEventListener('click', toggleSound);
            video.removeEventListener('play', updatePlay);
            video.removeEventListener('pause', updatePlay);
            video.removeEventListener('canplay', tryPlay);
            motion.removeEventListener('change',updateMotion); el.removeEventListener('click',click); el.removeEventListener('keydown',keydown);
        };
    },[navigate]);
    return <div className="sp-v21-home" ref={root} dangerouslySetInnerHTML={{__html:referenceHomeContent}} />;
}
